module.exports = [{"id":"all","title":"Любой"},{"id":"yes","title":"Частник"},{"id":"no","title":"Компания"}]


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/dealers.json
// module id = 1151
// module chunks = 49